import { useEffect } from 'react';
import { getApiUrlAbsolute } from '../config/api';
import './AuthCallback.css';

/**
 * Production nginx typically serves the SPA for /auth/* and only proxies /api to Node.
 * ATOZAS is registered at /auth/atozas/callback, so this page forwards to the API callback.
 */
const AtozasSpaCallback = () => {
  useEffect(() => {
    const qs = window.location.search || '';
    window.location.replace(getApiUrlAbsolute(`/api/auth/atozas/callback${qs}`));
  }, []);

  return (
    <div className="auth-callback">
      <div className="callback-message success">
        <p>Signing you in with ATOZAS...</p>
      </div>
    </div>
  );
};

export default AtozasSpaCallback;
